import React, { useState } from 'react';
import FullPageSyncLoader from 'components/FullPageSyncLoader';
import { I18n } from 'core';
import { Colors } from 'styles';
import { ReactComponent as TrashIcon } from 'assets/icons/Trash.svg';
import PromotorInfo, { PrincipalEnum } from 'types/models/promotorInfo';
import styles from '../UsuarioDetailPage.module.scss';

interface PromotorTableProps {
  CommunitiesPromotor: PromotorInfo[] | null;
  handleCheckboxChange: (disp: PromotorInfo) => void; // Replace YourCommunityType with the actual type
  deleteComunidad: (disp: any) => void; // Replace YourCommunityType with the actual type
  toggleMostrarEnMapa: (disp: PromotorInfo, value: boolean) => void;
  loadingComunidadId?: number | null;
  loadingFetching?: boolean;
}

function PromotorTable({
  CommunitiesPromotor,
  handleCheckboxChange,
  deleteComunidad,
  toggleMostrarEnMapa,
  loadingComunidadId,
}: PromotorTableProps) {
  if (!CommunitiesPromotor) {
    return <FullPageSyncLoader icon />;
  }
  const [checkboxValue, setCheckboxValue] = useState(
    CommunitiesPromotor.map((disp) => disp.principal === PrincipalEnum.si),
  );

  if (CommunitiesPromotor.length === 0) {
    return (
      <table>
        <tbody>
          <tr className={styles.Sinboder}>
            <td className={styles.nodata}>{I18n.t('UsuarioDetailPage.Promotor.noData')}</td>
          </tr>
        </tbody>
      </table>
    );
  }
  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th>Comunidad</th>
          <th>Ocultar en el mapa</th>
          <th>Principal</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        {CommunitiesPromotor.map((disp, index) => (
          <tr key={disp.cau}>
            <td>
              {disp.nombre}- {disp.id_comunidad}
            </td>

            <td>
              <div className={styles.checkboxTable}>
                {loadingComunidadId === disp.id_comunidad ? (
                  <FullPageSyncLoader icon size={20} />
                ) : (
                  <input
                    type="checkbox"
                    checked={disp.ocultarEnElMapa === 'si'}
                    onChange={(e) => toggleMostrarEnMapa(disp, e.target.checked)}
                  />
                )}
              </div>
            </td>

            <td>
              <div className={styles.checkboxTable}>
                <input
                  id={`seleccionado-${disp.cau}`}
                  type="checkbox"
                  checked={checkboxValue[index]}
                  onChange={() => {
                    const updatedValues = [...checkboxValue];
                    updatedValues.fill(false);
                    updatedValues[index] = !checkboxValue[index];
                    setCheckboxValue(updatedValues);
                    handleCheckboxChange(disp);
                  }}
                />
              </div>
            </td>

            <td>
              <div
                className={styles.checkboxTable}
                onClick={() => deleteComunidad(disp)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') deleteComunidad(disp);
                }}
              >
                <TrashIcon height={25} width={25} fill={Colors.COLOR_ELECSUMGREEN} />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default React.memo(PromotorTable);
